export const reservationEnLocale = {
  'reservation.title': 'Your Tickets',
  'reservation.description':
    'Use your mobile device to display these tickets when you arrive at the venue. Once inside, keep them readily available to display to the users.',
} as const;

export const reservationEsLocale = {
  'reservation.title': 'Tus Entradas',
  'reservation.description':
    'Usa tu dispositivo móvil para mostrar estas entradas cuando llegues al lugar. Una vez dentro, mantenlas disponibles para mostrar a los usuarios.',
} as const;
